export default __webpack_public_path__ + "static/media/17.e1c8429d.jpg";